export default {
    HistoricoVotosDeliberacao: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "historico-votos-deliberacao"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/HistoricoVotosDeliberacao.js
// module id = 6wrz
// module chunks = 16